import { createSlice } from "@reduxjs/toolkit";

export const PAGINATION_SLICE = 'pagination';

const initialState = {
    page: 1,
    limit: 10,
    count: 0
};

export const paginationSlice = createSlice({
    name: PAGINATION_SLICE,
    initialState,
    reducers: {
        setPage(state, { payload }) {
            state.page = payload
        },
        setLimit(state, { payload }) {
            state.limit = payload
        },
        setCount(state, { payload }) {
            state.count = payload
        },
        clearPagination: (state) => {
            state.count = 0;
            state.limit = 10;
            state.page = 1;
        }
    },
});

export const selectPage = (state) => state[PAGINATION_SLICE].page;

export const selectLimit = (state) => state[PAGINATION_SLICE].limit;

export const selectCount = (state) => state[PAGINATION_SLICE].count;


export const {
    setPage,
    setCount,
    setLimit,
    clearPagination
} = paginationSlice.actions;

export default paginationSlice.reducer;